import { useTranslation } from 'react-i18next'
import { Button, Typography } from 'antd'
import { textSubtitle } from '../../styles/AuthStyles'
import { EnterCodeForm } from '../Forms/EnterCodeForm'

type CodeStepProps = {
  title: string
  subtitle: string
  onSubmit: (code: string) => void
  loading: boolean
  error: string | null
  cooldown: number
  onResend: () => void
  onChangeNumber?: () => void
  changeLabel?: string
}

export const CodeStep = ({
  title,
  subtitle,
  onSubmit,
  loading,
  error,
  cooldown,
  onResend,
  onChangeNumber,
  changeLabel,
}: CodeStepProps) => {
  const { t } = useTranslation()

  return (
    <div data-testid='code-step'>
      <Typography.Title
        level={2}
        data-testid='code-step-title'
        style={{ textAlign: 'center', marginBottom: '16px', fontWeight: 400 }}
      >
        {title}
      </Typography.Title>
      <Typography.Text
        type='secondary'
        data-testid='code-step-subtitle'
        style={{ ...textSubtitle, marginBottom: '40px' }}
      >
        {subtitle}
      </Typography.Text>
      <EnterCodeForm
        onFinish={(values) => onSubmit(values.code)}
        loading={loading}
        error={error ?? undefined}
      />
      <div className='mt-2 flex flex-col items-center gap-2'>
        <Button
          type='link'
          disabled={cooldown > 0}
          onClick={onResend}
          data-testid='code-step-resend'
        >
          {cooldown > 0 ? t('phone_auth_resend_wait', { seconds: cooldown }) : t('phone_auth_resend')}
        </Button>
        {onChangeNumber && (
          <Button
            type='link'
            onClick={onChangeNumber}
            data-testid='code-step-change-number'
          >
            {changeLabel ?? t('phone_auth_change_number')}
          </Button>
        )}
      </div>
    </div>
  )
}
